import gql from 'graphql-tag';
import axios from 'axios';

const UploadImageMutation = gql`
  mutation uploadLocationImage {
    data: uploadLocationImage {
      success
      image {
        url
        uploadUrl
      }
    }
  }
`;

export const uploadImage = async (client, params, isEvent = false) => {
  const url = await client.mutate({
    mutation: UploadImageMutation,
  });
  
  const uploadUrl = url?.data.data.image.uploadUrl;

  // The imageKey what need to send to the backend
  const accessUrl = url?.data.data.image.url;
  if (params.data.image){
    const file = params.data.image.rawFile;

    const response = await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    });
  }
  // const file = params.data.image.rawFile;

  // const response = await axios.put(uploadUrl, file, {
  //   headers: {
  //     'Content-Type': file.type,
  //   },
  // });

  return accessUrl;
};
